const descriptor = {
  "app_label": "estimation",
  "model_name": "exportmapping",
  "pagination": true,
  "columns": [
    {
      "name": "pk",
      "label": "ID",
      "help_text": null,
      "hidden": true,
      "identifier": true,
      "data_type": "int",
      "search": false,
      "sort": false
    },
    {
      "name": "name",
      "label": "Name",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "str",
      "ellipsis": true,
      "search": true,
      "sort": true
    },
    {
      "name": "subheading",
      "label": "Subheading",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": null,
      "child_path": "label",
      "search": true,
      "sort": true
    },
    {
      "name": "product",
      "label": "Product",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": null,
      "child_path": "name",
      "search": true,
      "sort": true
    },
    {
      "name": "usage",
      "label": "Usage",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": null,
      "child_path": "label",
      "search": true,
      "sort": true
    },
    {
      "name": "drop",
      "label": "Drop",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "bool",
      "search": false,
      "sort": false
    },
    {
      "name": "is_random_mapping",
      "label": "Is random mapping",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "bool",
      "search": false,
      "sort": false
    },
    {
      "name": "is_random_mapping_roof",
      "label": "Is random mapping roof",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "bool",
      "search": false,
      "sort": false
    },
    {
      "name": "is_random_mapping_frame",
      "label": "Is random mapping frame",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "bool",
      "search": false,
      "sort": false
    },
    {
      "name": "is_carters_random_mapping",
      "label": "Is carters random mapping",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "bool",
      "search": false,
      "sort": false
    },
    {
      "name": "is_bulk_mapping",
      "label": "Is bulk mapping",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "bool",
      "search": false,
      "sort": true
    },
    {
      "name": "modified",
      "label": "Modified",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "datetime",
      "search": false,
      "sort": true
    }
  ],
  "filter_by": [],
  "export_import": {
    "export": {
      "directly": false,
      "url_name": null,
      "filter_by": [
        {
          "label": "Export Mode",
          "name": "export_mode",
          "type": "choices",
          "choices": [
            [
              "normal",
              "Normal Export"
            ],
            [
              "initial",
              "Initial Export"
            ]
          ]
        },
        {
          "label": "Export Limit",
          "name": "limit",
          "type": "choices",
          "choices": [
            [
              "all",
              "All Records"
            ],
            [
              "100",
              "100 Records"
            ],
            [
              "500",
              "500 Records"
            ]
          ]
        }
      ]
    },
    "import": {
      "url_name": "api:admin:estimation:exportimportsession:import",
      "allow_initial_data": true,
      "fields": [],
      "example_format_string": "seq,"
    }
  }
}

export default descriptor